(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["unew-ai-image-labels"] && !Shopify.designMode) return;
  try {
    (() => {
  const config = document.getElementById('unew-ai-image-labels');
  if (!config || document.getElementById('unew-ai-layer')) return;
  const exceptions = new Set(JSON.parse(document.getElementById('unew-ai-hand-images').textContent).map(imageKey));
  const layer = document.createElement('div');
  layer.id = 'unew-ai-layer';
  const tooltip = document.createElement('div');
  tooltip.className = 'unew-ai-tooltip'; tooltip.id = 'unew-ai-tooltip'; tooltip.role = 'tooltip'; tooltip.hidden = true;
  layer.appendChild(tooltip); document.body.appendChild(layer);
  const entries = new Map();
  const visible = new Set();
  let rules = new Map();
  const registry = new Map();
  const pendingKeys = new Set();
  const waitingKeys = new Set();
  let resolveTimer = 0;
  let runningRequests = 0;
  let refreshedAt = Date.now();
  function queueLookup(keys) {
    for (const key of keys) if (key && !registry.has(key) && !pendingKeys.has(key)) waitingKeys.add(key);
    if (waitingKeys.size && !resolveTimer) resolveTimer = setTimeout(resolveImages, 40);
  }
  async function resolveImages() {
    resolveTimer = 0;
    if (runningRequests >= 2 || !waitingKeys.size) return;
    const keys = [...waitingKeys].slice(0, 20);
    for (const key of keys) { waitingKeys.delete(key); pendingKeys.add(key); }
    runningRequests++;
    const url = new URL(config.dataset.searchUrl, location.origin);
    url.searchParams.set('section_id', 'unew-ai-image-data');
    url.searchParams.set('q', keys.join('|'));
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 10000);
    try {
      const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', signal: controller.signal });
      if (!response.ok) throw new Error('Image registry unavailable');
      const documentData = new DOMParser().parseFromString(await response.text(), 'text/html');
      const source = documentData.getElementById('unew-ai-resolved-data');
      if (!source) throw new Error('Image registry response missing');
      const values = JSON.parse(source.textContent);
      const types = { 'Original': 'none', 'AI generiert': 'generated', 'AI bearbeitet': 'edited' };
      for (const key of keys) registry.set(key, types[values[key]] || '');
    } catch {
      for (const key of keys) registry.set(key, '');
    } finally {
      clearTimeout(timeout);
      for (const key of keys) pendingKeys.delete(key);
      runningRequests--;
      schedule();
      if (waitingKeys.size) resolveTimer = setTimeout(resolveImages, 40);
    }
  }
  let enabled = true;
  let frame = 0;
  let scanTimer = 0;
  let active = null;
  let pinned = false;
  let closeTimer = 0;
  const decorativeContext = '.unew-ai-editor, [data-unew-ai-ignore], .header__heading-logo-wrapper, .unew-trust-bar__icon, [class*="__logo"], [class*="__icon"], [class*="scrolling-logo"], .list-payment, .icon, .svg-wrapper';
  function imageKey(value) {
    try {
      return decodeURIComponent(new URL(value, location.href).pathname.split('/').pop())
        .replace(/_(?:\d+x\d*|x\d+|small|medium|large|grande|master|compact|thumb|pico|icon)(?:_crop_[a-z]+)?(?:@\dx)?(?=\.[^.]+$)/i, '');
    } catch { return ''; }
  }
  function readRules() {
    const source = document.getElementById('unew-ai-image-rules');
    let data = {};
    try { data = JSON.parse(source?.textContent || '{}'); } catch { return; }
    enabled = data.enabled !== false;
    rules = new Map();
    for (const type of ['generated','edited','none']) {
      for (const value of (data[type] || '').split(/\r?\n/)) {
        if (value.trim()) rules.set(imageKey(value.trim()), type);
      }
    }
    for (const rule of data.rules || []) {
      const value = rule.file?.trim() || rule.image;
      if (value && ['none','edited','generated'].includes(rule.type)) rules.set(imageKey(value), rule.type);
    }
  }
  function sources(element) {
    if (element.tagName === 'IMG') return [element.currentSrc || element.src];
    return [...getComputedStyle(element).backgroundImage.matchAll(/url\(["']?([^"')]+)["']?\)/g)].map(match => match[1]);
  }
  function imageType(element, urls) {
    if (element.closest(decorativeContext)) return 'none';
    if (urls.some(url => /(?:^|[-_\s])(?:logos?|icons?)(?:[-_\s.]|\d|$)|^(?:DHL|original_produkte|SALON_FINDER|BAR_CHART)\./i.test(imageKey(url)))) return 'none';
    const keys = urls.map(imageKey);
    queueLookup(keys);
    if (keys.some(key => !registry.has(key))) return 'pending';
    const types = keys.map(key => registry.get(key) || rules.get(key) || (exceptions.has(key) ? 'none' : 'edited'));
    if (types.includes('none')) return 'none';
    return types.includes('generated') ? 'generated' : 'edited';
  }
  function schedule() { if (!frame) frame = requestAnimationFrame(draw); }
  function close() {
    clearTimeout(closeTimer);
    if (active) { active.badge.setAttribute('aria-expanded','false'); active.badge.removeAttribute('aria-describedby'); }
    active = null; pinned = false; tooltip.hidden = true;
  }
  function show(entry) {
    clearTimeout(closeTimer);
    if (entry.badge.hidden) return;
    if (active !== entry) close();
    active = entry;
    entry.badge.setAttribute('aria-expanded','true');
    entry.badge.setAttribute('aria-describedby',tooltip.id);
    tooltip.textContent = entry.description; tooltip.hidden = false;
    placeTooltip();
  }
  function placeTooltip() {
    if (!active) return;
    const rect = active.badge.getBoundingClientRect();
    tooltip.textContent = active.description;
    tooltip.style.left = `${Math.max(8, Math.min(window.innerWidth-tooltip.offsetWidth-8,rect.right-tooltip.offsetWidth))}px`;
    tooltip.style.top = `${rect.top >= tooltip.offsetHeight + 14 ? rect.top-tooltip.offsetHeight-8 : rect.bottom+8}px`;
  }
  tooltip.addEventListener('pointerenter', () => clearTimeout(closeTimer));
  tooltip.addEventListener('pointerleave', event => {
    if (active && !pinned && event.relatedTarget !== active.badge && document.activeElement !== active.badge) close();
  });
  const intersection = new IntersectionObserver(changes => {
    for (const change of changes) {
      if (change.isIntersecting) visible.add(change.target);
      else { visible.delete(change.target); const entry=entries.get(change.target); if(entry) { entry.badge.hidden=true; if(active===entry) close(); } }
    }
    schedule();
  }, { rootMargin: '0px' });
  const resize = new ResizeObserver(schedule);
  function register(element) {
    if (entries.has(element) || element.closest('#unew-ai-layer, .unew-ai-editor, [data-unew-ai-ignore]')) return;
    const badge = document.createElement('button');
    badge.type = 'button'; badge.className = 'unew-ai-image-label'; badge.textContent = config.dataset.label;
    badge.setAttribute('aria-expanded','false'); badge.hidden = true;
    const entry = { badge, description: config.dataset.edited };
    badge.addEventListener('pointerenter', event => { if(event.pointerType !== 'touch') show(entry); });
    badge.addEventListener('pointerleave', event => { if(active===entry && !pinned && document.activeElement!==badge && event.relatedTarget!==tooltip) { clearTimeout(closeTimer); closeTimer=setTimeout(()=>{if(active===entry && !pinned && document.activeElement!==badge)close();},180); } });
    badge.addEventListener('focus', () => show(entry));
    badge.addEventListener('blur', () => { if(active===entry) close(); });
    badge.addEventListener('click', event => {
      event.preventDefault(); event.stopPropagation();
      if(active===entry && pinned) close(); else { show(entry); pinned=true; }
    });
    layer.appendChild(badge); entries.set(element,entry); intersection.observe(element); resize.observe(element);
  }
  function scan() {
    for (const element of document.querySelectorAll('img')) register(element);
    for (const element of document.querySelectorAll('.shopify-section [class], .shopify-section [style]')) {
      if (element.tagName!=='IMG' && !element.closest('#unew-ai-layer, .unew-ai-editor') && getComputedStyle(element).backgroundImage.includes('url(')) register(element);
    }
    schedule();
  }
  function draw() {
    frame=0;
    const computed=new Map();
    const styleOf=element=>{ if(!computed.has(element)) computed.set(element,getComputedStyle(element)); return computed.get(element); };
    for(const element of visible) {
      const entry=entries.get(element); if(!entry) continue;
      const badge=entry.badge, urls=sources(element), rect=element.getBoundingClientRect();
      const type=imageType(element,urls);
      let hidden=!enabled || !element.isConnected || !urls.length || (type==='none' || type==='pending') || rect.width<30 || rect.height<30;
      if(element.tagName==='IMG' && (!element.complete || !element.naturalWidth)) hidden=true;
      let left=0,top=0,right=window.innerWidth,bottom=window.innerHeight;
      for(let parent=element;parent && !hidden;parent=parent.parentElement) {
        const style=styleOf(parent);
        if(style.visibility==='hidden' || style.display==='none' || Number(style.opacity)<.1) hidden=true;
        if(parent!==element && parent!==document.body && parent!==document.documentElement) {
          const clip=parent.getBoundingClientRect();
          if(/hidden|clip|scroll|auto/.test(style.overflowX)) { left=Math.max(left,clip.left);right=Math.min(right,clip.right); }
          if(/hidden|clip|scroll|auto/.test(style.overflowY)) { top=Math.max(top,clip.top);bottom=Math.min(bottom,clip.bottom); }
        }
      }
      if(!hidden) {
        badge.hidden=false;
        const size=badge.offsetWidth, inset=rect.width>80 && rect.height>60?8:2;
        const x=rect.right-size-inset,y=rect.bottom-size-inset;
        hidden=x<left || y<top || x+size>right || y+size>bottom;
        badge.style.left=`${x}px`;badge.style.top=`${y}px`;
        entry.description=type==='generated'?config.dataset.generated:config.dataset.edited;
        badge.setAttribute('aria-label',entry.description);
        if(!hidden) {
          const hit=document.elementsFromPoint(x+size/2,y+size/2).find(node=>!layer.contains(node));
          if(hit && hit!==element && !element.contains(hit) && !hit.contains(element) && !element.parentElement?.contains(hit) && !element.closest('.shopify-section')?.contains(hit)) hidden=true;
        }
      }
      badge.hidden=hidden;
      if(hidden && active===entry) close();
    }
    if(active) placeTooltip();
  }
  const mutations=new MutationObserver(changes=>{
    if(!changes.some(change=>!layer.contains(change.target) && !(change.type==='childList' && [...change.addedNodes,...change.removedNodes].every(node=>node===layer)))) return;
    schedule();
    if(changes.some(change=>change.type==='childList' && !layer.contains(change.target))) {
      clearTimeout(scanTimer);scanTimer=setTimeout(()=>{
        for(const [element,entry] of entries) if(!element.isConnected) {
          if(active===entry) close();entry.badge.remove();intersection.unobserve(element);resize.unobserve(element);visible.delete(element);entries.delete(element);
        }
        scan();
      },80);
    }
  });
  readRules();scan();
  mutations.observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['src','srcset','class','style','hidden','open','data-unew-ai-ignore']});
  document.addEventListener('pointerdown',event=>{if(!layer.contains(event.target))close();});
  document.addEventListener('keydown',event=>{if(event.key==='Escape')close();});
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible' && Date.now() - refreshedAt > 5000) {
      refreshedAt = Date.now(); registry.clear(); schedule();
    }
  });
  window.addEventListener('focus', () => {
    if (Date.now() - refreshedAt > 5000) { refreshedAt = Date.now(); registry.clear(); schedule(); }
  });
  document.addEventListener('load',schedule,true);
  document.addEventListener('scroll',schedule,{capture:true,passive:true});
  window.addEventListener('resize',schedule,{passive:true});
  for(const event of ['pointerover','pointerout','focusin','focusout','transitionend','animationend']) document.addEventListener(event,()=>{schedule();setTimeout(schedule,250);},true);
  document.addEventListener('shopify:section:load',()=>{readRules();scan();});
  document.addEventListener('shopify:section:unload',()=>{setTimeout(()=>{readRules();scan();},0);});
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["unew-market-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('unew-market-selector')) {
    customElements.define('unew-market-selector', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.dialog = this.querySelector('dialog');
        this.form = this.querySelector('form');
        this.countryInput = this.form.querySelector('[name="country_code"]');
        this.key = this.dataset.storageKey;
        this.currentCountry = this.dataset.country;
        this.dirty = false;
        this.form.addEventListener('change', () => { this.dirty = true; });
        this.form.addEventListener('submit', (event) => {
          event.preventDefault();
          this.choose(this.form.querySelector('[name="unew_market_choice"]:checked').value);
        });
        this.querySelector('[data-market-close]').addEventListener('click', () => this.choose('DE'));
        this.dialog.addEventListener('cancel', (event) => { event.preventDefault(); this.choose('DE'); });
        document.addEventListener('click', (event) => {
          const link = event.target.closest('[data-unew-market-country]');
          if (!link) return;
          this.remember(this.normalize(link.dataset.value));
        }, true);
        const saved = this.savedChoice();
        if (saved) {
          this.switchCountry(saved);
          return;
        }
        if (this.dataset.authenticated === 'true') {
          this.switchCountry(this.normalize(this.dataset.customerCountry));
          return;
        }
        this.recommendCountry();
        if (typeof this.dialog.showModal === 'function') this.dialog.showModal();
      }

      normalize(country) { return country === 'AT' ? 'AT' : 'DE'; }

      savedChoice() {
        for (const storage of ['localStorage', 'sessionStorage']) {
          try {
            const value = JSON.parse(window[storage].getItem(this.key));
            if (value && ['AT', 'DE'].includes(value.country) && value.expires > Date.now()) return value.country;
          } catch (_) {}
        }
        return null;
      }

      remember(country) {
        const value = JSON.stringify({ country, expires: Date.now() + 90 * 24 * 60 * 60 * 1000 });
        for (const storage of ['localStorage', 'sessionStorage']) {
          try { window[storage].setItem(this.key, value); } catch (_) {}
        }
      }

      choose(country) {
        this.dirty = true;
        this.remember(country);
        this.dialog.close();
        this.switchCountry(country, true);
      }

      switchCountry(country, manual = false) {
        if (country === this.currentCountry) {
          try { sessionStorage.removeItem(this.key + '-redirect'); } catch (_) {}
          return;
        }
        try {
          const last = JSON.parse(sessionStorage.getItem(this.key + '-redirect'));
          if (!manual && last && last.country === country && Date.now() - last.time < 30000) return;
          sessionStorage.setItem(this.key + '-redirect', JSON.stringify({ country, time: Date.now() }));
        } catch (_) {
          if (!manual) return;
        }
        this.countryInput.value = country;
        this.form.querySelectorAll('[name="unew_market_choice"]').forEach(input => { input.disabled = true; });
        this.form.submit();
      }

      async recommendCountry() {
        const controller = new AbortController();
        const timer = setTimeout(() => controller.abort(), 1800);
        try {
          const root = this.dataset.root.replace(/\/$/, '') + '/';
          const response = await fetch(root + 'browsing_context_suggestions.json?country[enabled]=true&language[enabled]=false', {
            credentials: 'same-origin', signal: controller.signal
          });
          if (!response.ok) return;
          const data = await response.json();
          const country = this.normalize(data.detected_values?.country?.handle);
          if (!this.dirty && this.dialog.open) {
            this.form.querySelector('[name="unew_market_choice"][value="' + country + '"]').checked = true;
          }
        } catch (_) {
        } finally { clearTimeout(timer); }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
